<!-- <app-academies-header></app-academies-header> -->

<div class="col-md-12 d-flex justify-content-center mb-3 headers-headings mobile-header-div"><a onclick="history.back()"
    class="mobile-header"><i class="bx bx-chevron-left"></i> {{tournamentName}} </a></div>
<p-toast key="toastmsg"></p-toast>
<div class="tabs-bar">
  <ul class="nav nav-tabs">
    <li class="nav-item " style="display: flex;">
      <a class="mobile-header" onclick="history.back()" style="display: flex;align-items: center;">
        <i class="bx bx-chevron-left" style="color: #fff; font-size: 1.6em;"></i> </a>
    </li>
    <li class="nav-item">
      <a class="nav-link " aria-current="page" routerLink="/tournaments/factsheet/{{tournamentId}}"
        [routerLinkActive]="'active'">INFO
      </a>
    </li>
    <li class="nav-item">
      <a *ngIf="isTournamentDrawView" [routerLinkActive]="'active'" class="nav-link"
        routerLink="/tournament-draw/{{tournamentId}}" [routerLinkActive]="'active'">
        DRAWS</a>
      <a *ngIf="!isTournamentDrawView" [routerLinkActive]="'active'" class="nav-link"
        routerLink="/tournament-draw-view/{{tournamentId}}" [routerLinkActive]="'active'">
        DRAWS</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/result/{{tournamentId}}">RESULTS </a>
    </li>

  </ul>
</div>
<div class="loader-image" style="width: 100%;height: 100%; object-fit: contain;">


  <div class="screen-short-loader">
    <img src="assets/img/loader/gif.gif" alt=""
      style="width: 170px!important;height: 170px!important; object-fit: contain;">
    <h4 class="text-center">Please Wait</h4>
    <p class="text-center">Converting your draw into an image. Please wait for the magic to happen!</p>
  </div>
</div>
<section class="body-section academies-profile-inner main-section-form draw-section" #captureMe
  [ngClass]="{ 'highlighted-section': isHighlighted }">
  <div class="container">
    <!-- <h1 class="text-center text-capitalize">{{tournamentName}}</h1> -->
    <div class="drawer-box ml-0 mr-0"
      [ngClass]="[totalEntries === 8 ?  'class1' : 'drawer-box' &&  totalEntries === 16 ? 'class2' : 'drawer-box' &&  totalEntries === 32 ? 'class3' : 'drawer-box'  &&  totalEntries === 64 ? 'class4' : 'drawer-box' &&  totalEntries === 128 ? 'class5' : 'drawer-box'  ]">
      <form [formGroup]="drawForm">
        <div class="row text-center categeory-row">
          <div class="p-field p-col-8 d-flex categeory-selection-div ">
            <div class="dropdown-div">
              <label for="categoryType">Select Category: </label>
              <p-dropdown [style]="{'max-width':'180px'}" inputId="categoryType" [options]="categoryList"
                formControlName="categoryType" [filter]="true" placeholder="Select Category" optionLabel="matchTypeName"
                [ngClass]="{ 'is-invalid': submitted && f.categoryType.errors }"
                (onChange)="onSelectCategory($event)"></p-dropdown>
              <div *ngIf="submitted && f.categoryType.errors.required" class="invalid-feedback">
                Please select Match type
              </div>
            </div>
            <div class="dropdown-div">
              <label for="ageGroup">Select Age Group: </label>
              <p-dropdown [autoDisplayFirst]="false" [style]="{'max-width':'180px'}" inputId="ageGroup"
                [options]="ageGroupList" formControlName="ageGroup" [filter]="true" placeholder="Select Age Group"
                optionLabel="ageGroupName" [ngClass]="{ 'is-invalid': submitted && f.ageGroup.errors }"
                (onChange)="onAgeGroupSelect($event)"></p-dropdown>
              <div *ngIf="submitted && f.ageGroup.errors.required" class="invalid-feedback">
                Please select Age Group
              </div>
            </div>
          </div>

          <div class="p-field p-col-4 justify-content-end ">
            <!-- <p-button class="mr-3 screenShort-btn" (click)="captureScreenshot()">
              <i class='bx bx-camera mr-2'></i> Screenshot
            </p-button> -->
            <p-button class="mr-3 btn-help  " (click)="helpModal()">
              <i class='bx bx-info-circle mr-2'></i> Help
            </p-button>
            <p-button *ngIf="!drawStatus" [disabled]="saveDrawButtonDisable" (onClick)="onClickSaveButton()">
              Finish Draw
            </p-button>
          </div>
        </div>
        <div *ngIf="totalEntriesArray.length > 0" class="draw-section-parent col-md-12">
          <div class="draw-header col-md-12 draw-main-body">
            <div class="round first-round">
              First round
            </div>
            <div *ngIf="totalEntries == 16 || totalEntries == 32 || totalEntries == 64 || totalEntries == 128"
              class="round first-round">
              Second round
            </div>
            <div *ngIf="totalEntries == 32 || totalEntries == 64 || totalEntries == 128" class="round first-round">
              Third round
            </div>
            <div *ngIf="totalEntries == 128" class="round first-round">
              Fourth round
            </div>
            <div *ngIf="totalEntries == 64 || totalEntries == 128" class="round first-round">
              Quarter Finals
            </div>
            <div class="round first-round">
              Semi finals
            </div>
            <div class="round first-round">
              Finals
            </div>
            <div class="round first-round">
              Winner
            </div>
          </div>

          <div class="col-md-12 draw-main-body">
            <div class="round first-round">
              <ul>
                <li *ngFor="let entry of totalEntriesArray;let i =index" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      {{i + 1}}
                    </div>
                    <div class=" player-details">
                      <div class="name-score">
                        <p-dropdown [style]="{'width':'180px'}" [autoDisplayFirst]="false" appendTo="body"
                          formControlName="player{{i+1}}" [options]=" playerList" [filter]="true"
                          inputId="playerDropdown" optionLabel="name" (onChange)="onClickPlayerDropdown($event, (i+1))">
                        </p-dropdown>
                      </div>
                      <div class="player-remove-button-div">
                        <i style="cursor: pointer; display: none;" id="player{{i+1}}_dot"
                          (click)="onClickIcon('player'+(i+1))" class='bx bx-dots-vertical-rounded'>
                        </i>
                        <button type="button" class="player-remove-button" style="display: none;"
                          id="reset_player{{i+1}}" pButton for="reset_player{{i+1}}" (click)="onClickReset((i+1))">
                          Remove Player</button>
                        <i style="cursor: pointer; display: none;" id="close_remove_player{{i+1}}"
                          (click)="onClickCloseRemoveIcon('player'+(i+1))" class='remove-close-button bx bx-x'></i>
                        <input type="hidden" for="reset_player{{i+1}}" formControlName="reset_player{{i+1}}">
                        <input type="hidden" for="reset_player{{i+1}}_position"
                          formControlName="reset_player{{i+1}}_position">
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="round second-round">
              <ul>
                <li *ngFor="let entry of secondRoundArray; let i=index" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      <a style="height: 44px;" data-original-title="" title="">
                        <span class="match-extras scores-draw-h2h-link threeDotsPopover ">
                          <i style="cursor: pointer; display: block;"
                            id="enter_three_dot_player{{entry.index}}_player{{entry.index + 1}}_round1"
                            pTooltip="Enter Result" (click)="onClickEnterThreeDotsIcon('1', (entry.index))"
                            class='bx bx-dots-vertical-rounded'></i>
                          <i style="cursor: pointer; display: none;"
                            id="enter_edit_three_dot_player{{entry.index}}_player{{entry.index + 1}}_round1"
                            (click)="onClickEnterEditThreeDotsIcon('1', (entry.index))" pTooltip="Discard Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <ul class="enter-result-list">
                            <li>
                              <div class="enter-close-div"
                                id="enter_close_div_player{{entry.index}}_player{{entry.index + 1}}_round1"
                                style="display: none;">
                                <i style="display: none;"
                                  id="close_player{{entry.index}}_player{{entry.index + 1}}_round1"
                                  (click)="onClickCloseIcon('1', (entry.index))" class="bx bx-x"></i>
                                <button type="button" style="display: none;"
                                  id="enter_player{{entry.index}}_player{{entry.index + 1}}_round1" pButton
                                  for="enter_player{{entry.index}}_player{{entry.index + 1}}_round1"
                                  (click)="onClickEnterIcon('1', (entry.index))">
                                  Enter Result
                                </button>
                                <button type="button" style="display: none;"
                                  id="enter_edit_player{{entry.index}}_player{{entry.index + 1}}_round1" pButton
                                  for="enter_edit_player{{entry.index}}_player{{entry.index + 1}}_round1"
                                  (click)="onClickEnterEditIcon('1', (entry.index))">
                                  Discard Result
                                </button>

                                <i style="display: none;"
                                  id="close_edit_player{{entry.index}}_player{{entry.index + 1}}_round1"
                                  (click)="onClickCloseEditIcon('1', (entry.index))" class="bx bx-x"></i>
                              </div>
                            </li>
                          </ul>
                        </span>
                      </a>
                    </div>
                    <div class=" player-details">
                      <div class=" name-score">
                        <div class="main-scroew">
                          <div class="round-winner">
                            <p>
                              <input class="winner-text" readonly value="TBD"
                                id="winner_player{{entry.index}}_player{{entry.index + 1}}_round1">
                              <input class="winner-text" readonly type="hidden" value="TBD"
                                id="winner_id_player{{entry.index}}_player{{entry.index + 1}}_round1">
                            </p>
                            <div class="winner-score"
                              id="winner_concede_player{{entry.index}}_player{{entry.index + 1}}_round1"
                              style="display: none;">
                              <!-- <input class="winner-score" readonly style="display: none;"
                                        > -->
                            </div>
                            <p><input class="winner-score" type="hidden" readonly id="player{{entry.index}}_round2">
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="round third-round">
              <ul>
                <li *ngFor="let thirdEntry of thirdRoundArray; let i= index" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      <a style="height: 44px;" data-original-title="" title="">
                        <span class="match-extras scores-draw-h2h-link threeDotsPopover ">
                          <i style="cursor: pointer; display: block;"
                            id="enter_three_dot_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                            pTooltip="Enter Result" (click)="onClickRoundThreeDotsIcon('2',(thirdEntry.index))"
                            class='bx bx-dots-vertical-rounded'></i>
                          <i style="cursor: pointer; display: none;"
                            id="enter_edit_three_dot_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                            (click)="onClickRoundEditThreeDotsIcon('2', (thirdEntry.index))" pTooltip="Discard Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <ul class="enter-result-list">
                            <li>
                              <div class="enter-close-div"
                                id="enter_close_div_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                                style="display: none;">
                                <i style="display: none;"
                                  id="close_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                                  (click)="onClickRoundCloseIcon('2',(thirdEntry.index))" class="bx bx-x"></i>
                                <button type="button" style="display: none;"
                                  id="enter_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2" pButton
                                  for="enter_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                                  (click)="onClickEnterRound('2', (thirdEntry.index))">
                                  Enter Result
                                </button>
                                <button type="button" style="display: none;"
                                  id="enter_edit_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                                  pButton
                                  for="enter_edit_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                                  (click)="onClickEnterEditIcon('2', (thirdEntry.index))">
                                  Discard Result
                                </button>
                                <i style="display: none;"
                                  id="close_edit_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2"
                                  (click)="onClickRoundCloseEditIcon('2', (thirdEntry.index))" class="bx bx-x"></i>
                              </div>
                            </li>
                          </ul>
                        </span>
                      </a>
                    </div>
                    <div class=" player-details">
                      <div class=" name-score">
                        <div class="main-scroew">
                          <div class="round-winner">
                            <p>
                              <input class="winner-text" readonly value="TBD"
                                id="winner_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2">
                              <input class="winner-text" type="hidden" readonly value="TBD"
                                id="winner_id_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2">
                            </p>
                            <div class="winner-score" class="winner-score" readonly style="display: none;"
                              id="winner_concede_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2">
                            </div>
                            <p><input class="winner-score" type="hidden" readonly
                                id="player{{thirdEntry.index}}_round3">
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="round fourth-round">
              <ul>
                <li *ngFor="let fourthEntry of fourthRoundArray" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      <a style="height: 44px;" data-original-title="" title="">
                        <span class="match-extras scores-draw-h2h-link threeDotsPopover ">
                          <i style="cursor: pointer; display: block;"
                            id="enter_three_dot_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                            (click)="onClickRoundThreeDotsIcon('3',(fourthEntry.index))" pTooltip="Enter Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <i style="cursor: pointer; display: none;"
                            id="enter_edit_three_dot_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                            (click)="onClickRoundEditThreeDotsIcon('3', (fourthEntry.index))" pTooltip="Discard Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <ul class="enter-result-list">
                            <li>
                              <div class="enter-close-div"
                                id="enter_close_div_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                                style="display: none;">
                                <i style="display: none;"
                                  id="close_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                                  (click)="onClickRoundCloseIcon('3', (fourthEntry.index))" class="bx bx-x"></i>
                                <button type="button" style="display: none;"
                                  id="enter_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3" pButton
                                  for="enter_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                                  (click)="onClickEnterRound('3', (fourthEntry.index))">
                                  Enter Result
                                </button>
                                <button type="button" style="display: none;"
                                  id="enter_edit_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                                  pButton
                                  for="enter_edit_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                                  (click)="onClickEnterEditIcon('3', (fourthEntry.index))">
                                  Discard Result
                                </button>

                                <i style="display: none;"
                                  id="close_edit_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3"
                                  (click)="onClickRoundCloseEditIcon('3', (fourthEntry.index))" class="bx bx-x"></i>

                              </div>

                            </li>
                          </ul>
                        </span>
                      </a>
                    </div>
                    <div class=" player-details">
                      <div class=" name-score">
                        <div class="main-scroew">
                          <div class="round-winner">
                            <p>
                              <input class="winner-text" readonly value="TBD"
                                id="winner_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3">
                              <input class="winner-text" readonly type="hidden" value="TBD"
                                id="winner_id_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3">
                            </p>
                            <div class="winner-score" readonly style="display: none;"
                              id="winner_concede_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3">
                            </div>
                            <p><input class="winner-score" type="hidden" readonly
                                id="player{{fourthEntry.index}}_round4">
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div *ngIf="totalEntries == 16 || totalEntries == 32 || totalEntries == 64 || totalEntries == 128"
              class="round fifth-round">
              <ul>
                <li *ngFor="let fifthEntry of fifthRoundArray" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      <a style="height: 44px;" data-original-title="" title="">
                        <span class="match-extras scores-draw-h2h-link threeDotsPopover ">
                          <i style="cursor: pointer; display: block;"
                            id="enter_three_dot_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                            (click)="onClickRoundThreeDotsIcon('4',(fifthEntry.index))" pTooltip="Enter Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <i style="cursor: pointer; display: none;"
                            id="enter_edit_three_dot_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                            (click)="onClickRoundEditThreeDotsIcon('4', (fifthEntry.index))" pTooltip="Discard Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <ul class="enter-result-list">
                            <li>
                              <div class="enter-close-div"
                                id="enter_close_div_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                                style="display: none;">
                                <i style="display: none;"
                                  id="close_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                                  (click)="onClickRoundCloseIcon('4', (fifthEntry.index))" class="bx bx-x"></i>
                                <button type="button" style="display: none;"
                                  id="enter_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4" pButton
                                  for="enter_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                                  (click)="onClickEnterRound('4', (fifthEntry.index))">
                                  Enter Result
                                </button>
                                <button type="button" style="display: none;"
                                  id="enter_edit_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                                  pButton
                                  for="enter_edit_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                                  (click)="onClickEnterEditIcon('4', (fifthEntry.index))">
                                  Discard Result
                                </button>

                                <i style="display: none;"
                                  id="close_edit_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                                  (click)="onClickRoundCloseEditIcon('4', (fifthEntry.index))" class="bx bx-x"></i>
                              </div>

                            </li>
                          </ul>
                        </span>
                      </a>
                    </div>
                    <div class=" player-details">
                      <div class=" name-score">
                        <div class="main-scroew">
                          <div class="round-winner">
                            <p>
                              <input class="winner-text" readonly value="TBD"
                                id="winner_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4">
                              <input class="winner-text" readonly type="hidden" value="TBD"
                                id="winner_id_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4">
                            </p>
                            <div class="winner-score"
                              id="winner_concede_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                              style="display: none;">
                              <!-- <input class="winner-score" readonly style="display: none;"
                                                            > -->
                            </div>
                            <p><input class="winner-score" type="hidden" readonly
                                id="player{{fifthEntry.index}}_round5">
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div *ngIf="totalEntries == 32 || totalEntries == 64 || totalEntries == 128" class=" round sixth-round">
              <ul>
                <li *ngFor="let sixthEntry of sixthRoundArray" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      <a style="height: 44px;" data-original-title="" title="">
                        <span class="match-extras scores-draw-h2h-link threeDotsPopover ">
                          <i style="cursor: pointer; display: block;"
                            id="enter_three_dot_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                            (click)="onClickRoundThreeDotsIcon('5',(sixthEntry.index))" pTooltip="Enter Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <i style="cursor: pointer; display: none;"
                            id="enter_edit_three_dot_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                            (click)="onClickRoundEditThreeDotsIcon('5', (sixthEntry.index))" pTooltip="Discard Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <ul class="enter-result-list">
                            <li>
                              <div class="enter-close-div"
                                id="enter_close_div_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                                style="display: none;">

                                <button type="button" style="display: none;"
                                  id="enter_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5" pButton
                                  for="enter_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                                  (click)="onClickEnterRound('5', (sixthEntry.index))">
                                  Enter Result
                                </button>
                                <button type="button" style="display: none;"
                                  id="enter_edit_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                                  pButton
                                  for="enter_edit_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                                  (click)="onClickEnterEditIcon('5', (sixthEntry.index))">
                                  Discard Result
                                </button>
                                <i style="display: none;"
                                  id="close_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                                  (click)="onClickRoundCloseIcon('5', (sixthEntry.index))" class="bx bx-x"></i>
                                <i style="display: none;"
                                  id="close_edit_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                                  (click)="onClickRoundCloseEditIcon('5', (sixthEntry.index))" class="bx bx-x"></i>
                              </div>

                            </li>
                          </ul>
                        </span>
                      </a>
                    </div>
                    <div class=" player-details">
                      <div class=" name-score">
                        <div class="main-scroew">
                          <div class="round-winner">
                            <p>
                              <input class="winner-text" readonly value="TBD"
                                id="winner_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5">
                              <input class="winner-text" readonly type="hidden" value="TBD"
                                id="winner_id_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5">
                            </p>
                            <div class="winner-score"
                              id="winner_concede_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                              style="display: none;">
                              <!-- <input class="winner-score" readonly style="display: none;"
                                                              > -->
                            </div>
                            <p><input class="winner-score" type="hidden" readonly
                                id="player{{sixthEntry.index}}_round6">
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div *ngIf="totalEntries == 64 || totalEntries == 128" class=" round seven-round">
              <ul>
                <li *ngFor="let seventhEntry of seventhRoundArray" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      <a style="height: 44px;" data-original-title="" title="">
                        <span class="match-extras scores-draw-h2h-link threeDotsPopover ">
                          <i style="cursor: pointer; display: block;"
                            id="enter_three_dot_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                            (click)="onClickRoundThreeDotsIcon('6',(seventhEntry.index))" pTooltip="Enter Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <i style="cursor: pointer; display: none;"
                            id="enter_edit_three_dot_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                            (click)="onClickRoundEditThreeDotsIcon('6', (seventhEntry.index))" pTooltip="Discard Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <ul class="enter-result-list">
                            <li>
                              <div class="enter-close-div"
                                id="enter_close_div_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                style="display: none;">
                                <i style="display: none;"
                                  id="close_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                  (click)="onClickRoundCloseIcon('6', (seventhEntry.index))" class="bx bx-x"></i>
                                <button type="button" style="display: none;"
                                  id="enter_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                  pButton
                                  for="enter_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                  (click)="onClickEnterRound('6', (seventhEntry.index))">
                                  Enter Result
                                </button>
                                <button type="button" style="display: none;"
                                  id="enter_edit_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                  pButton
                                  for="enter_edit_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                  (click)="onClickEnterEditIcon('6', (seventhEntry.index))">
                                  Discard Result
                                </button>

                                <i style="display: none;"
                                  id="close_edit_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                  (click)="onClickRoundCloseEditIcon('6', (seventhEntry.index))" class="bx bx-x"></i>
                              </div>

                            </li>
                          </ul>
                        </span>
                      </a>
                    </div>
                    <div class=" player-details">
                      <div class=" name-score">
                        <div class="main-scroew">
                          <div class="round-winner">
                            <p>
                              <input class="winner-text" readonly value="TBD"
                                id="winner_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6">
                              <input class="winner-text" readonly type="hidden" value="TBD"
                                id="winner_id_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6">
                            </p>
                            <div class="winner-score"
                              id="winner_concede_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                              style="display: none;">
                              <!-- <input class="winner-score" readonly style="display: none;"
                                                                          > -->
                            </div>
                            <p><input class="winner-score" type="hidden" readonly
                                id="player{{seventhEntry.index}}_round7">
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div *ngIf="totalEntries == 128" class="round final-round">
              <ul>
                <li *ngFor="let eightEntry of eightRoundArray" class=" player">
                  <div class=" player-main">
                    <div class=" SL-number">
                      <a style="height: 44px;" data-original-title="" title="">
                        <span class="match-extras scores-draw-h2h-link threeDotsPopover ">
                          <i style="cursor: pointer; display: block;"
                            id="enter_three_dot_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                            (click)="onClickRoundThreeDotsIcon('7',(eightEntry.index))" pTooltip="Enter Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <i style="cursor: pointer; display: none;"
                            id="enter_edit_three_dot_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                            (click)="onClickRoundEditThreeDotsIcon('7', (eightEntry.index))" pTooltip="Discard Result"
                            class='bx bx-dots-vertical-rounded'></i>
                          <ul class="enter-result-list">
                            <li>
                              <div class="enter-close-div"
                                id="enter_close_div_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                                style="display: none;">
                                <i style="display: none;"
                                  id="close_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                                  (click)="onClickRoundCloseIcon('7', (eightEntry.index))" class="bx bx-x"></i>
                                <button type="button" style="display: none;"
                                  id="enter_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7" pButton
                                  for="enter_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                                  (click)="onClickEnterRound('7', (eightEntry.index))">
                                  Enter Result
                                </button>
                                <button type="button" style="display: none;"
                                  id="enter_edit_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                                  pButton
                                  for="enter_edit_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                                  (click)="onClickEnterEditIcon('7', (eightEntry.index))">
                                  Discard Result
                                </button>

                                <i style="display: none;"
                                  id="close_edit_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                                  (click)="onClickRoundCloseEditIcon('7', (eightEntry.index))" class="bx bx-x"></i>
                              </div>

                            </li>
                          </ul>
                        </span>
                      </a>
                    </div>
                    <div class=" player-details">
                      <div class=" name-score">
                        <div class="main-scroew">
                          <div class="round-winner">
                            <p>
                              <input class="winner-text" readonly value="TBD"
                                id="winner_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7">
                              <input class="winner-text" readonly type="hidden" value="TBD"
                                id="winner_id_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7">
                            </p>
                            <div class="winner-score"
                              id="winner_concede_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                              style="display: none;">
                              <!-- <input class="winner-score" readonly style="display: none;"
                                                              > -->
                            </div>
                            <p><input class="winner-score" type="hidden" readonly
                                id="player{{eightEntry.index}}_round8">
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>
</section>
<p-dialog [closable]="true" header="Add Result" multiple="multiple" [(visible)]="showScoreForm" [modal]="true"
  id="add-logos" [style]="{width: '500px'}" [baseZIndex]="10000" (onHide)="onCloseModal()" [draggable]="false"
  [resizable]="false" id="result-modal">
  <div class="add-score-result-main-div">
    <form [formGroup]="scoreForm">
      <div class="col-md-12 form-div">
        <div class="row score-div-result ">
          <div class="col-md-5 text-center">
            <p *ngIf="playerOneDetails !== undefined && playerTwoDetails !== undefined && showDetailScoringCheckBox"
              class="strong text-capitalize firstPlayerName">
              <span class="player-lable-popup">
                {{playerOneDetails.name}}
              </span>
            </p>
            <p-inputNumber *ngIf="showDetailScoringCheckBox" [style]="{'width':'100%', 'text-align':'center'}"
              formControlName="playerOne" id="firstPlayerScore" [min]="0" [max]="5" mode="decimal" [showButtons]="true"
              class="input-error" (onBlur)="createSetsDetailsInputs('blur',$event)"
              (onInput)="createSetsDetailsInputs('keyup', $event)" placeholder="Enter player score">
            </p-inputNumber>
          </div>
          <div class="col-md-2 dropdownss text-center" style="text-align: center;">
            <p-dropdown [style]="{'width':'100%', 'text-align':'center'}" [autoDisplayFirst]="false"
              [options]="matchConcedeCategories" formControlName="matchConcedeCategoryDropDown"
              (onChange)="onChangeMatchConcedeCategory($event)" optionLabel="name" appendTo="body">
            </p-dropdown>
          </div>
          <div class="col-md-5 text-center">
            <p class="strong text-capitalize secondPlayerName"
              *ngIf="playerOneDetails !== undefined && playerTwoDetails !== undefined && showDetailScoringCheckBox">
              <span class="player-lable-popup">
                {{playerTwoDetails.name}}
              </span>
            </p>
            <p-inputNumber *ngIf="showDetailScoringCheckBox" [style]="{'width':'100%', 'text-align':'center'}"
              formControlName="playerTwo" id="secondPlayerScore" [showButtons]="true"
              (onBlur)="createSetsDetailsInputs('blur', $event)" (onInput)="createSetsDetailsInputs('keyup',$event)"
              placeholder="Enter player score" [min]="0" [max]="5" mode="decimal" class=" input-error">
            </p-inputNumber>
          </div>
        </div>
        <div class="text-center text-danger" *ngIf="showScoreInputError">
          <span class="text-center text-danger">
            Please enter different value for players.
          </span>
        </div>
        <div class="col-md-12 text-center select-winner-div" *ngIf="showPlayerRadioButtons">
          <span class="title-winner">Select Winner :</span>
          <div class="winner-div-main">
            <div *ngIf="playerOneDetails !== undefined && playerTwoDetails !== undefined" class="palyer-winner-div">
              <label class="text-capitalize" for="playerOneRadio">{{playerOneDetails.name}}</label>
              <p-radioButton value={{playerOneDetails.id}} formControlName="playerOneRadio"
                [(ngModel)]="selectedPlayerValue" (onClick)="onRadioButtonClick(playerOneDetails)"
                inputId="playerOneRadio"></p-radioButton>
            </div>
            <div *ngIf="playerOneDetails !== undefined && playerTwoDetails !== undefined" class="palyer-winner-div">
              <label class="text-capitalize" for="playerTwoRadio">{{playerTwoDetails.name}}</label>
              <p-radioButton value={{playerTwoDetails.id}} formControlName="playerTwoRadio" inputId="playerTwoRadio"
                [(ngModel)]="selectedPlayerValue" (onClick)="onRadioButtonClick(playerTwoDetails)"></p-radioButton>
            </div>
          </div>
          <div *ngIf="showRadioButtonError" class="alert-validation-red">
            <span class="text-danger">Please select winner.</span>
          </div>
        </div>
      </div>
      <div *ngIf="showDetailScoringCheckBox" class="col-md-12 form-div text-center mb-3">
        <div class="form-check p-pl-0 d-flex  ">
          <p-checkbox formControlName="matchConcedeCategoryCheckbox" binary="true" inputId="Detailedscoring"
            (onChange)="onCheckDetail($event)"></p-checkbox>
          <label for="Detailedscoring" style="text-align: center; margin-bottom: 0px; margin-left: 0.5rem;"> Detailed
            Scoring</label>
        </div>
      </div>
    </form>
    <div class="col-md-12 form-div score-sets-div" *ngIf="showSetScoreTable">
      <form [formGroup]="scoreInputForm">
        <div class="row ">
          <div class="col-md-6 titles">
            Sets
          </div>
          <div class="col-md-6 titles">
            Tiebreak
          </div>
          <!-- <div class="col-md-2" style="text-align: center; padding: 0px;">
            Duration (min.)
          </div> -->
        </div>
        <div formArrayName="scoreArray">
          <div class="row " *ngFor="let set of scoreSectionForm().controls;let i=index;" [formGroupName]="i">
            <div class="row col-md-6  text-center score-table">
              <div class="col-md-6">
                <p-inputNumber [showButtons]="true" [min]="0" mode="decimal" class="" inputId="player1Set{{i}}"
                  formControlName="player1Set"
                  [ngClass]="{ 'is-invalid':  scoreSubmitted && set.get('player1Set').errors }"></p-inputNumber>

                <div *ngIf="scoreSubmitted && set.get('player1Set').hasError('required')" class="invalid-feedback">
                  Player one score.
                </div>
              </div>
              <div class="col-md-6  text-center">
                <p-inputNumber [showButtons]="true" [min]="0" mode="decimal" class="" inputId="player2Set{{i}}"
                  formControlName="player2Set"
                  [ngClass]="{ 'is-invalid':  scoreSubmitted && set.get('player2Set').errors }"></p-inputNumber>
                <div *ngIf="scoreSubmitted && set.get('player2Set').hasError('required')" class="invalid-feedback">
                  Player two score.
                </div>
              </div>
            </div>
            <div class="row col-md-6  text-center score-table">
              <div class="col-md-6">
                <p-inputNumber [showButtons]="true" [min]="0" mode="decimal" class="" inputId="player1Tiebreak{{i}}"
                  formControlName="player1TieBreak"></p-inputNumber>
              </div>
              <div id="player1TieBreak_error{{i}}" style="display:none">
                <span class="text-danger">
                  Please enter tiebreak one value.
                </span>
              </div>

              <div class="col-md-6  text-center">
                <p-inputNumber [showButtons]="true" [min]="0" mode="decimal" class="" inputId="player2Tiebreak{{i}}"
                  formControlName="player2TieBreak"></p-inputNumber>
              </div>
              <div id="player2TieBreak_error{{i}}" style="display:none">
                <span class="text-danger">
                  Please enter tiebreak two value.
                </span>
              </div>

              <div id="playerTieBreak_same_error{{i}}" style="display:none">
                <span class="text-danger">
                  Please enter different value for tiebreak.
                </span>
              </div>
            </div>
            <!-- <div class="row col-md-2  text-center">
              <div class="col-md-12">
                <p-inputNumber class="" [showButtons]="true" [min]="0" inputId="duration{{i}}"
                  formControlName="duration"
                  [ngClass]="{ 'is-invalid':  scoreSubmitted && set.get('duration').errors }"></p-inputNumber>
                <div *ngIf="scoreSubmitted && set.get('duration').hasError('required')" class="invalid-feedback">
                  Please add duration in minutes.
                </div>
              </div> 
          </div> -->
          </div>
        </div>
      </form>
    </div>
    <div class="text-center text-align" *ngIf="errorOneResult">
      <span class="text-danger">Please add result.</span>
    </div>
    <div class="text-center text-align" *ngIf="showWrongScoreError">
      <span class="text-danger">Please add correct result.</span>
    </div>
    <div class="text-center text-align" *ngIf="detailResultError">
      <span class="text-danger">Please enter detailed result.</span>
    </div>
    <!-- <div class="row">
      <div class="col-md-6 text-right">
        <button (click)="onScoreSubmit()" pButton class="text-center text-align" type=" submit">Save</button>
      </div> -->
    <!-- <div *ngIf="showSetScoreTable" class="col-md-6 text-right">
        <button (click)="onScoreReset()" pButton class="text-center text-align" type=" submit">Reset Detailed
          Result</button>
      </div> -->
    <!-- </div> -->


  </div>

  <ng-template pTemplate="footer">
    <button (click)="onScoreSubmit()" pButton class="text-center text-align" type=" submit"><i class="bx bx-save"></i>
      Save</button>
  </ng-template>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


<p-dialog header="Guidelines for creating a tournament draw" [(visible)]="helpPopupModal" [modal]="true"
  [style]="{ width: '600px' }" [draggable]="false" [resizable]="false" id="helpPopup"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
  <div class="list">
    <ul>
      <li>
        If "Bye" is selected against a player in the first round, the player will display automatically in the second
        round without inserting the result.
      </li>
      <li>
        If the "Bye" result is discarded, the same player will be unable to enter the result. In this case, remove the
        player who was added against "Bye" and then re-add the same player.
      </li>
    </ul>
  </div>
</p-dialog>